import { debounce } from "lodash";
import { Grid } from "@mui/material";
import { Fragment, useEffect, useState } from "react";

import { useAxios } from "../../hooks";
import EmptyList from "../misc/EmptyList";
import List from "./unverified list components/List";
import { Loader, PageHeader } from "../../components";
import SortBy from "./unverified list components/SortBy";
import Search from "./unverified list components/Search";
import VerifiedList from "./unverified list components/VerifiedList";
import Pagination from "../../components/Pagination";

export default function UnverifiedBrandList() {
  const axios = useAxios();

  const [page, setPage] = useState(1);
  const [brands, setBrands] = useState([]);
  const [sortBy, setSortBy] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [brandStatus, setBrandStatus] = useState();
  const [lastPage, setLastPage] = useState({
    totalCount: 0,
    lastPage: false,
  });

  useEffect(() => {
    axios({
      url:
        "/getAllBrands?page=" +
        page +
        "&limit=10" +
        (sortBy !== "" ? "&is_brand_verified=" + sortBy : "") +
        (Boolean(searchKey) ? "&search=" + encodeURIComponent(searchKey) : ""),
      method: "GET",
      disableRedirect: false,
    }).then((response) => {
      if (response.status) {
        setBrands(response.data.parsedBrands);

        setLastPage({
          totalCount: response.data.totalCount,
          lastPage: response.data.parsedBrands.length < 10,
        });
      } else {
        setBrands([]);

        setLastPage({
          totalCount: response.data?.totalCount || 0,
          lastPage: false,
        });
      }
    });
  }, [axios, brandStatus, page, sortBy, searchKey]);

  const handleSearchDebounce = debounce(async (value) => {
    setSearchKey(value);
  }, 300);

  function handlePagination(step, index) {
    setPage((prev) =>
      step === "index" ? index : prev + (step === "next" ? 1 : -1)
    );
  }

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <PageHeader
            icons={[
              <SortBy
                sortBy={sortBy}
                setPage={setPage}
                setSortBy={setSortBy}
              />,
              <Search
                setPage={setPage}
                handleSearchDebounce={handleSearchDebounce}
              />,
            ]}
            pageName={"Brands"}
            pageHeader={"List of brands"}
          />
        </Grid>
      </Grid>

      <Loader height="75%">
        {brands.length > 0 ? (
          sortBy === 1 ? (
            <VerifiedList brandList={brands} />
          ) : (
            <List brands={brands} setBrandStatus={setBrandStatus} />
          )
        ) : (
          <EmptyList title={""} />
        )}
      </Loader>

      {parseInt(lastPage.totalCount) > 0 && (
        <Grid
          item
          container
          style={{ marginTop: "20px" }}
          display={"flex"}
          justifyContent={"center"}
        >
          <Pagination
            count={Math.ceil(lastPage.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
